<small *ngIf="dates">
  <span
    class="text-muted font-italic"
    *ngIf="dates.fromDate === null && dates.toDate === null && !showUntilNow; else dateRange">
    {{ 'common.unknown' | translate }}
  </span>

  <ng-template #dateRange>
    <!--At least one date is known-->
    <span *ngIf="!dates.fromDate">
      {{ 'common.unknown' | translate }}
    </span>
    <span *ngIf="dates.fromDate">
      {{ dates.fromDate | date: dateFormat }}
    </span>
    -
    <span *ngIf="dates.toDate">
      {{ dates.toDate | date: dateFormat }}
    </span>
    <span *ngIf="!dates.toDate" class="text-muted font-italic">
      {{ 'common.today' | translate }}
    </span>
  </ng-template>

  <ng-template #dateRange>
    <!--At least one date is known-->
    <span *ngIf="!dates.fromDate">
      {{ 'common.unknown' | translate }}
    </span>
    <span *ngIf="dates.fromDate">
      {{ dates.fromDate | date: dateFormat }}
    </span>
    -
    <span *ngIf="dates.toDate">
      {{ dates.toDate | date: dateFormat }}
    </span>
    <span *ngIf="!dates.toDate" class="text-muted font-italic">
      {{ 'common.today' | translate }}
    </span>
  </ng-template>
</small>

<!--
  If neither from_date or to_date exist we can show "unknown" in both fields.
  If we are showing to_date, it might also be null if the entity is currently active
-->
